/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState,useRef} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer,resetArrays } from "../../redux/MultiselectRows"
import Table from "./Components"
import TopBarMonitor from "./TopBarMonitor"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import ConfirmationPrompt from "../../components/ConfirmationPrompt"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import { useEditMonitorUserMutation, useGetMonitorsQuery } from "../../features/manageMonitorSlice"
import { useExportMonitorMutation } from "../../features/manageMonitorSlice"
import { handleAddFilterValues, resetFilterState, handleSidebarPrvState } from "../../redux/systemConfigSlice"
import { handleLastChangedParam } from "../../redux/commonSlice"
import ProviderSearch from "../ManageProvider/Components/AdvancedSearch"
import { resetProviderSearch, setProSearchApplied } from "../../redux/providerSearchSlice"

function camelToSnakeCase(str) {
    if(str==="Username"){
        return "user_name"
    }
   
    else if(str==="ID"){
        return "user_id"
    }
    else if(str==="Permissions"){
        return "monitor_permission"
    }
    else if(str==="Mobile Number"){
        return "mobile_number_with_code"
    }
    else if(str==="Main Number"){
        return "main_number_with_code"
    }
  
    else{
        return str.replace(/ /g, '_').toLowerCase();
    }
}
function snakeToCamelCase(str) {
    if(str==="user_id"){
        return "ID"
    }else if(str==="user_name"){
        return "Username"
    }else if(str==="monitor_permission"){
        return "Permission"
    }else if(str==="main_number_with_code"){
        return "Main Number"
    }else if(str==="mobile_number_with_code"){
        return "Mobile Number"
    }
    else{
        return str.replace(/_([a-z])/g, function (match, group) {
            return group.toUpperCase();
        }).replace(/([A-Z])/g, function (match, group) {
            return ' ' + group;
        }).replace(/^./, function(match) {
            return match.toUpperCase();
        }).trim();
    }
    
}

export default function ManageMonitorUser(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,setIsSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    
    const [editUser]=useEditMonitorUserMutation()
    const [exportMonitorUsers]=useExportMonitorMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [page_number,setPageNUmber]=useState("1")
    const [searchParams, setSearchParams] = useSearchParams({});
    const acceptedSearchCols=["user_id","user_name","first_name","last_name","email_address","status","mobile_number_with_code","main_number_with_code","monitor_permission"]
    // const [selected,setSelected]=useState(searchParams?.get("search_column")!==null && acceptedSearchCols.includes(searchParams?.get("search_column"))?snakeToCamelCase(searchParams?.get("search_column")):"Last Name" )
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [loading,setLoading]=useState(false)
    const [isSortselected,setisSortSelected]=useState(false)
    const selectedRows=useSelector((state)=>state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const [confirmationState, setConfirmationState] = useState({isOpen:false,rowData:'',multirow:'',user_names:[]});
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [emptyField,setEmptyField]=useState(false);
    const auth=useSelector(state=>state?.auth)
    const loc_key=useSelector(state=>state?.systemConfigData?.location_key)
    const lastChangedParam=useSelector(state=>state?.commonData?.lastChangedParam)
    const providerSearch = useSelector(state => state.providerSearchData);
    const [searchDatePartialFilledState,setSearchDatePartialFilledState]=useState(false)
    const searchApplied = useSelector((state) => state.providerSearchData.prosearchApplied);


    
    let searchOption=""
    const optionRef=useRef()
    const {userType} = auth
    const initialState={
        "status":'',
        "monitor_permission":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)

    useEffect(() => {
        const status = searchParams.get('status')
        const monitor_permission = searchParams.get('monitor_permission')
        if (status || monitor_permission) {
            setFilterValues({
                status: status ? status.split(',') : '',
                monitor_permission: monitor_permission ? monitor_permission.split(',') : '',
            })
        }
    }, [searchParams])

    // const [trigger, result, lastPromiseInfo] = useLazyGetUsersQuery({refetchOnFocus:false });

    const {data,isFetching,isLoading,status}=useGetMonitorsQuery(searchParams?.toString(),{skip: skip||location.search===''||(searchParams.get("search")===null&&searchParams.get("search_column")!==null&&lastChangedParam==="search_column")})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */

    const handleSearchParams = (key, value) => {
        dispatch(handleLastChangedParam(key))
        let params = Object.fromEntries(searchParams);
        // Only reset page_number to 1 if we're not explicitly setting page_number
        if (key !== 'page_number') {
            params.page_number = 1
        }
        if(key === 'search') {
            params[key] = encodeURIComponent(value) 
            // params['search_column']=camelToSnakeCase(selected)
        }
        
        else params[key] = value
        if (params.search === '') {delete params.search 
            // delete params.search_column
        }
        setSearchParams({ ...params})
    }
    useEffect(() => {
        if(location.state!==null&&location.state!==''&& !Array.isArray(location.state)){
            const params = { limit: '15', page_number: '1', ...location.state }
            if (params.search) params.search = decodeURIComponent(params.search)
            else delete params.search
            setSearchParams(params)
            if (params.search_mode && !isAdvancedSearchOpen) {
                dispatch(handleSidebarPrvState(isSideBar))
                setIsAdvancedSearchOpen(true)
                setIsSideBar(false)
            }
        }
        else{
            // Only initialize default values if no search params exist
            const params = Object.fromEntries(searchParams)
            let changed = false
            if(!params.limit){ params.limit = '15'; changed = true }
            if(!params.page_number){ params.page_number = '1'; changed = true }
            if(changed) setSearchParams(params, { replace: true })
        }

        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=2){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
       
            
    },[searchParams])
    
    // useEffect(()=>{
    //     if(location.state===null){
    //         handleSearchParams("search_column",camelToSnakeCase(selected))
    //     } 
            
    // },[selected])

    useEffect(()=>{
        dispatch(handleLastChangedParam(""))
    },[])
   

    
    function handleNoOfRowsClick(number) {
        dispatch(handleLastChangedParam("page_number"))
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        dispatch(handleLastChangedParam("page_number"))
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
       
        
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleCheckboxChange = (event, type) => {
        const { id, checked } = event.target;
        setFilterValues((prevState) => {
            const newState = { ...prevState };
            newState[type] = checked
                ? [...(newState[type] || []), id]
                : (newState[type] || []).filter((item) => item !== id);
            return newState;
        });
    };

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
    
        if (type) {
            dispatch(handleLastChangedParam("filter"))
            params.filter = "true";
    
            // Dispatch the filter values to Redux
            dispatch(handleAddFilterValues({
                status: filterValues.status,
                monitor_permission: filterValues.monitor_permission
            }));
    
            // Filter out empty values before updating searchParams
            const filteredStatus = filterValues.status && filterValues.status.length > 0
                ? filterValues.status.join(',')
                : null;
    
            const filteredPermissionAccess = filterValues.monitor_permission && filterValues.monitor_permission.length > 0
                ? filterValues.monitor_permission.join(',')
                : null;
    
            if (filteredStatus) {
                params['status'] = filteredStatus;
            } else {
                delete params['status'];
            }
    
            if (filteredPermissionAccess) {
                params['monitor_permission'] = filteredPermissionAccess;
            } else {
                delete params['monitor_permission'];
            }
    
            setSearchParams({ ...params });
        } else {
            // Clear filterValues when type is false
            setFilterValues({
                status: [],
                monitor_permission: [],
                // Add other properties if needed
            });
    
            // Remove filter-related keys from searchParams
            delete params['status'];
            delete params['monitor_permission'];
            delete params['filter'];
    
            setSearchParams({ ...params });
        }
    };
    

    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setEmptyField(false)
        setTextAreaMsg("")
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        
        if((confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""&&confirmationState?.rowData?.status === 'active' && textAreaMsg.trim()=== '')||(confirmationState?.multirow==="deactive"&&(textAreaMsg.trim()===''))){ 
            setToastErrorMessage('Please fill in the mandatory field')
            setEmptyField(true)
            return;
        }
        try {
            let body = { }
            if(confirmationState?.rowData!==undefined&&confirmationState?.rowData!==""){
                {confirmationState?.rowData?.status === 'inactive' ?
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : ''
                    } : 
                    body={
                        "user_names": [confirmationState?.rowData.user_name],
                        "status":confirmationState?.rowData?.status==="inactive"?"active":"inactive",
                        "note" : textAreaMsg 
                    } 
                }
            }
            else{
                confirmationState?.multirow==="deactive"?
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : textAreaMsg 
                    }
                    :
                    body={
                        "user_names": (selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name),
                        "status":confirmationState?.multirow==="deactive"?"inactive":"active",
                        "note" : ''
                        
                    }
            }
            setLoading(true)
            
            

            const activationRes=await editUser({body})
            setLoading(false)
            
            if(activationRes?.error){
                setToastErrorMessage('Something went wrong. Please try again')
            }else{
                if(confirmationState?.multirow!==""&&confirmationState?.multirow!==undefined){
                    setToastmessage(`Monitor users ${confirmationState?.multirow==="active"?"activated":"deactivated"} successfully`);
                }
                else{
                    setToastmessage(`Monitor user ${confirmationState?.rowData?.status==="inactive"?"activated":"deactivated"} successfully`);
                }
            }
            setTextAreaMsg('');
            dispatch(resetArrays())
            setConfirmationState({})
           
        } catch (error) {
            setConfirmationState({});
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }  

    // apply search function
    const handleOnSubmit = (e) => {
        e.preventDefault();
    
        let searchString = '';
    
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => value?.trim() === '-' ? '__NULL__' : value?.trim() || '';
    
        // Fields that support inverse conditions
        const fields = [
            { key: 'user_id', inverse: 'user_id_inverse' },
            { key: 'first_name', inverse: 'first_name_inverse' },
            { key: 'last_name', inverse: 'last_name_inverse' },
        ];
    
        fields.forEach(({ key, inverse }) => {
            const value = formatSearchValue(providerSearch?.[key]);
            if (value) {
                const prefix = providerSearch?.[inverse] ? 'ne:' : '';
                searchString += `${key}=${prefix}${encodeURIComponent(value)};`;
            }
        });
    
        // Special case fields with domain (email & username)
        const domainFields = [
            { key: 'user_name', domain: 'user_name_domain', inverse: 'user_name_inverse' },
            { key: 'email_address', domain: 'email_address_domain', inverse: 'email_address_inverse' },
        ];
    
        domainFields.forEach(({ key, domain, inverse }) => {
            const value = formatSearchValue(providerSearch?.[key]);
            const domainValue = formatSearchValue(providerSearch?.[domain]);
            if (value || domainValue) {
                const prefix = providerSearch?.[inverse] ? 'ne:' : '';
                searchString += `${key}=${prefix}${encodeURIComponent(value)}@${encodeURIComponent(domainValue)};`;
            }
        });
    
        // Special case for phone numbers (mobile & main)
        const phoneFields = [
            { code: 'mobile_number_code', number: 'mobile_number', inverse: 'mobile_number_inverse', key: 'mobile_country_code-mobile_number' },
            { code: 'main_number_code', number: 'main_number', inverse: 'main_number_inverse', key: 'main_country_code-main_number' },
        ];
    
        phoneFields.forEach(({ code, number, inverse, key }) => {
            const countryCode = formatSearchValue(providerSearch?.[code]);
            const num = formatSearchValue(providerSearch?.[number]);
            if (countryCode || num) {
                const prefix = providerSearch?.[inverse] ? 'ne:' : '';
                searchString += `${key}=${prefix}${countryCode ? '+' : ''}${encodeURIComponent(countryCode)}-${encodeURIComponent(num)};`;
            }
        });
    
        // Handle Created Date
        const { created_day, created_month, created_year, created_date_inverse } = providerSearch || {};
        const isPartialDate = [created_day, created_month, created_year].filter(Boolean).length !== 0 && [created_day, created_month, created_year].filter(Boolean).length !== 3;
    
        if (isPartialDate) {
            setSearchDatePartialFilledState(true);
            return;
        } else if (created_day && created_month && created_year) {
            const dateStr = `${created_year}-${String(created_month).padStart(2, '0')}-${String(created_day).padStart(2, '0')}`;
            const date = new Date(`${dateStr}T00:00:00`);
            const epochDate = Math.floor(date.getTime() / 1000);
            const prefix = created_date_inverse ? 'ne:' : '';
            searchString += `created_at=${prefix}${epochDate};`;
        }
    
        // Remove trailing ';' if present
        searchString = searchString.replace(/;$/, '');
    
        // Merge new parameters
        const currentParams = Object.fromEntries(searchParams);
        const newParams = {
            ...currentParams,
            search: searchString || '',
            search_mode: providerSearch.match === false ? 'and' : 'or',
            page_number: 1,
            limit: currentParams.limit || '15',
        };
    
        if (!newParams.search) delete newParams.search;
    
        setSearchParams(newParams);
        dispatch(setProSearchApplied());
    };
    

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetProviderSearch());
        }
    }, [dispatch, searchApplied]);
   

    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Monitor Users"}/>
                <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6 ">
                        <TopBarMonitor 
                            title={'List of Monitor Users'}
                            path={'/manage-monitor-user/add-monitor-user'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            SearchPlaceholder={'Search for ID,Username etc'}
                            buttonName={"Add Monitor User"}
                            menuBar={(data!==undefined&&data?.data?.length!==0&&selectedRows?.length>0) ? true : false}
                            ApplyFilter={((searchParams.get("monitor_permission")===null&&searchParams.get("status")===null)&&(data?.data?.length===0 || data===undefined))?false:true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            toAddScreen={'/manage-monitor-user/add-monitor-user'}
                            setConfirmationState={setConfirmationState}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID','Username','First Name','Last Name','Status','Email Address','Mobile Number','Main Number','Permission','Created Date']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportUsers={exportMonitorUsers}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            handleCheckboxChange={handleCheckboxChange}
                            handleApplyFilter={handleApplyFilter}
                            isIdexport={true}
                            // selected={selected}
                            handleSearchParams={handleSearchParams}
                            snakeToCamelCase={snakeToCamelCase}
                            // setSelected={setSelected}
                            camelToSnakeCase={camelToSnakeCase}
                            optionRef={optionRef}
                        
                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Monitor User list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}

                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC]" >
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false") || (searchParams.get("status")!==null||searchParams.get("monitor_permission")!==null) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreen
                                title={"Manage Organization Users"}
                                FirstPTag={"No Organization users added yet."}
                                SecondePTag={"Start managing by clicking 'Add user'"}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
                {confirmationState.isOpen  && 
                    <AnimatedModel 
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyField}
                                setEmptyField={setEmptyField}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={handleConformationClick}
                                tittle= {confirmationState?.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==="active"?'Activate':'Deactivate'}
                                message = {confirmationState.rowData!==""?`Are you sure you want ${confirmationState?.rowData?.status==="inactive"? 'activate' : 'deactivate'} this Monitor user?`:
                                    `Are you sure you want to ${confirmationState.multirow==='active'?'activate':'deactivate'} the following monitor users?`}
                                textMessage = {confirmationState.rowData!==""?confirmationState?.rowData?.status === 'inactive' ? true : false:confirmationState.multirow==="active"?true:false}
                                buttonName = {confirmationState.rowData!==""?confirmationState?.rowData?.status==="inactive"? 'Activate' : 'Deactivate':confirmationState.multirow==='active'?'Activate':'Deactivate'}
                                userList={confirmationState?.multirow===''?'':confirmationState?.multirow==="deactive"?(selectedRows?.filter((user)=>user.status!=='inactive'))?.map((item)=>item.name):(selectedRows?.filter((user)=>user.status!=='active'))?.map((item)=>item.name)}
                                loadingActivation={loading}
                            />
                        }
                    /> 
                }
                {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <ProviderSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={searchDatePartialFilledState}
                    setEmptyField={setSearchDatePartialFilledState}
                    monitorPageSearch={true}
                />
                }
            </div>
        </>
   
    )
}